interface PublishableProduct {
  createdAt: string;
  publishedAt?: string | null;
}

/**
 * The date an announcement went live. Falls back to the creation date for
 * products saved before publishedAt existed.
 */
export const getPublishedAt = (product: PublishableProduct): string =>
  product.publishedAt || product.createdAt;

const DAY_MS = 86_400_000;

/**
 * Whole calendar days from today to an expiration day ("YYYY-MM-DD", the day the listing goes offline).
 * Negative once the day has passed.
 */
export const daysUntilExpiration = (expirationDate: string, now = new Date()): number => {
  const [year, month, day] = expirationDate.split('-').map(Number);
  const expiresOn = Date.UTC(year, month - 1, day);
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((expiresOn - today) / DAY_MS);
};

/** Romanian day count: "1 zi", "5 zile", "52 de zile" (numbers ending 20-99 or 00 take "de"). */
export const formatDayCount = (days: number): string => {
  if (days === 1) return '1 zi';
  const lastTwoDigits = days % 100;
  return days >= 20 && (lastTwoDigits === 0 || lastTwoDigits >= 20) ? `${days} de zile` : `${days} zile`;
};

const expirationDayFormat = new Intl.DateTimeFormat('ro-RO', { day: 'numeric', month: 'short', year: 'numeric' });

/** "13 dec. 2026" for an expiration day, read as a calendar date (no timezone shift). */
export const formatExpirationDay = (expirationDate: string): string => {
  const [year, month, day] = expirationDate.split('-').map(Number);
  return expirationDayFormat.format(new Date(year, month - 1, day));
};
